import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "lib-flexible-computer"

// 自定义（components）
import Mynav from '@/components/header/index';
Vue.component("Mynav", Mynav);//全局自定义组件
import Myfooter from '@/components/footer/index';
Vue.component("Myfooter", Myfooter);//全局自定义组件

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 轮播
import vueSwiper from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.css'
Vue.use(vueSwiper) 

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if(from.path == '/newsDetail' && to.path == '/news'){
  //   to.meta.keepAlive = true;
  // }else{
  //   to.meta.keepAlive = false;
  // }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
